import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from '../../../../../node_modules/rxjs';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable()
export class AuthenticationService {
  private authUrl = `${environment.base_api_uri}/uaa/oauth/token`;

  constructor(private http: HttpClient, private _router: Router) {}

  login(email: string, password: string): Promise<any> {
    let body: any = {
      username: email,
      password: password,
      client_id: environment.client_id,
      grant_type: 'password',
      client_secret: environment.client_secret
    };

    let form = `client_id=${body.client_id}&client_secret=${body.client_secret}&username=${body.username}&password=${body.password}&grant_type=${body.grant_type}`;

    let headers = new HttpHeaders (
      {
        'Content-Type':'application/x-www-form-urlencoded'
      }
    );

    return new Promise((resolve, reject) => {
      this.http.post(this.authUrl , form, {headers: headers}).subscribe(response => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('token', JSON.stringify(response));
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  }

  refreshToken() {
    let api_token = JSON.parse(localStorage.getItem('token'));

    if (!api_token) {
      let noTokenObservable : Observable<any>;
      noTokenObservable = new Observable(observer => {
        setTimeout(() => {
          observer.next({status: 401});
        }, 1000);
      });
      this.logout();
      return noTokenObservable.map((res) => {
        return res;
      })
    }
    let body: any = {
      client_id: environment.client_id,
      grant_type: 'refresh_token',
      refresh_token: api_token.refresh_token,
      jti: api_token.jti,
      client_secret: environment.client_secret
    };

    let form = `client_id=${body.client_id}&jti=${body.jti}&grant_type=${body.grant_type}&refresh_token=${body.refresh_token}&client_secret=${body.client_secret}`;

    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    return this.http.post(this.authUrl , form, {headers: headers})
      .map((response: any) => {
        if (response) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          // localStorage.removeItem('currentUser');
          localStorage.setItem('token', JSON.stringify(response));

          response['isRefreshToken'] = true;
          return response;
        }
      });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token');

    this._router.navigate(['/login']);
  }

  passwordRecovery(email: string) {
    let form = {
      email: email
    };
    return this.http.post(`${environment.base_api_uri}/users/password/recovery`, form)
      .map((response: any) => {
        if (response) {
          return response;
        }
      });
  }

  passwordReset(recoveryToken: any,body: any) {
    let form = {
      "password": body.password,
      "passwordConformation": body.passwordConformation
    };
    return this.http.post(`${environment.base_api_uri}/users/password/reset/${recoveryToken}`, form)
      .map((response: any) => {
        if (response) {
          return response;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/_services/authentication.service.ts